import PoliticaConfidentialitate from './PoliticaConfidentialitate';

export default function RoPrivacy() {
  return <PoliticaConfidentialitate />;
}
